import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { ResponseBadRequest } from '@interfaces/.';
import { Store } from '@ngrx/store';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isUnauthorizedShown = false;
  private isTimeoutShown = false;     // Estado compartido para 408
  private debounceTime = 5000;

  constructor(private router: Router, private store: Store) {}
  
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(({ error }: HttpErrorResponse) => {
        const { error: errors, message } = error;

        let errorMessage: ResponseBadRequest = {
          success: false,
          statusCode: error?.statusCode,
          propagate: this.isUnauthorizedShown || this.isTimeoutShown ? true : false,
          message: 'An unexpected error occurred',
          error: ''
        };
        
        if (error instanceof ErrorEvent) {
          errorMessage.message = message;
          errorMessage.error = 'Client Error';
        } else {
          errorMessage.message = message || errors?.error || errors?.message || message?.message || error?.error || 'Unknown server error';
          errorMessage.error = errorMessage.message || 'Server Error';
          
          if (error.statusCode === 401 && !this.isUnauthorizedShown) {
            this.isUnauthorizedShown = true;
            this.router.navigate(['/login'], { replaceUrl: true });
            setTimeout(() => this.isUnauthorizedShown = false, this.debounceTime);
          }
          
          if (error.statusCode === 408 && !this.isTimeoutShown) {
            this.isTimeoutShown = true;
            setTimeout(() => this.isTimeoutShown = false, this.debounceTime);
          }
        }

        return throwError(() => errorMessage);
      })
    );
  }
}